// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"31d6cfe0","89":"11396b37","115":"2fed936d","219":"b8bdec88","292":"363ab23f","352":"ca91d79d","964":"97f9afad"}[chunkId] + ".chunk.css";
};